import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA   } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { defineLocale } from 'ngx-foundation/chronos';
import { esLocale } from 'ngx-foundation/locale';
import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


defineLocale('es', esLocale);

import {
  AccordionModule,
  AlertModule,
  BsDatepickerModule,
  BsDropdownModule,
  CollapseModule,
  TabsModule,
  ModalModule,
} from 'ngx-foundation';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { ProfileSelectorComponent } from './profile-selector/profile-selector.component';
import { ProfileService } from './_services/profiles.service';
import { LogoutComponent } from './logout/logout.component';
import { TramitesComponent } from './tramites/tramites.component';
import { TramiteComponent } from './tramites/tramite/tramite.component';
import { TramiteStartComponent } from './tramites/tramite-start/tramite-start.component';
import { ConsultasComponent } from './consultas/consultas.component';
import { LoginComponent } from './login/login.component';
import { ReportesComponent } from './reportes/reportes.component';
import { UserAdministrationComponent } from './user-administration/user-administration.component';
import { SafePipe } from './_shared/dom.sanitizer';
import { TramiteEmpresaComponent } from './tramite-empresa/tramite-empresa.component';
import { EnvironmentServiceProvider } from './_providers/environment.service.provider';
import { VisorTramiteComponent } from './visor-tramite/visor-tramite.component';
import { CertificadosComponent } from './certificados/certificados.component';
import { ModalComponent } from './modal/modal.component';
import { RequestInterceptor } from './_services/http-error.interceptor';
import { DetalleComponent } from './detalle/detalle.component';
import { ModalCAComponent } from './_components/modalCA/modalCA.component';


import {MsalInterceptor, MsalModule, MsalAngularConfiguration} from '@azure/msal-angular'
import { environment } from 'src/environments/environment';
import { EnvironmentService } from './_services/environment.service';

import { DxPopupModule, DxSelectBoxModule } from 'devextreme-angular';
import { CertificadosmasivosComponent } from './certificadosmasivos/certificadosmasivos.component';

const env:any =[];

// Read Environment Variables from browser
const browserWindow = window || {};
const environmentKey = '__env';
const broswerWindowEnvironment = browserWindow[environmentKey] || {};

for (const key in broswerWindowEnvironment) {
  if (broswerWindowEnvironment.hasOwnProperty(key)) {
    env[key] = window[environmentKey][key];
  }
}
let strClientId = env.clientId;
let strRedirectUrl = env.appReturnURL;

  const authUrl= window.sessionStorage.getItem("authURL");
  if (!authUrl){
    window.sessionStorage.setItem("authURL","https://cafamb2c.b2clogin.com/cafamb2c.onmicrosoft.com/B2C_1A_PERSONAS_SIGNIN_RP");
  }
  let authority = window.sessionStorage.getItem("authURL");

  // Some logic to determine core MSAL.js configuration
  let config: any = {
    auth:{
      clientId: strClientId, // "4c9142fe-8e48-44e6-ab94-b6ca0833ad21", // Application Id of Application registered in B2C
      authority: authority,
      validateAuthority:false,
      redirectUri: strRedirectUrl
    },
    cache:{
      cacheLocation:"sessionStorage",
      storeAuthStateInCookie:false
    },
    system: {
      tokenRenewalOffsetSeconds: 300  // 5 minutos antes de la expiración del token
    }
  };


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ProfileSelectorComponent,
    LogoutComponent,
    TramitesComponent,
    TramiteComponent,
    TramiteStartComponent,
    ConsultasComponent,
    LoginComponent,
    ReportesComponent,
    UserAdministrationComponent,
    SafePipe,
    TramiteEmpresaComponent,
    VisorTramiteComponent,
    CertificadosComponent,
    CertificadosmasivosComponent,
    ModalComponent,
    DetalleComponent,
    ModalCAComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    FontAwesomeModule,
    MsalModule.forRoot(config,{
      consentScopes:[
        "user.read","openid","profile"
      ]
    }),
    DxSelectBoxModule,
    DxPopupModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ], // Agrega CUSTOM_ELEMENTS_SCHEMA aquí
  providers: [ProfileService, EnvironmentServiceProvider, {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent],
})
export class AppModule {}
